import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatOption } from '@angular/material/core'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { ComprasOrdemServicoService } from '../../../core/services/reserva-compras/compras-ordem-servico/compras-ordem-servico.service'
import { SupplierService } from '../../../core/services/person/supplier/supplier.service'
import { AuthService } from '../../../core/services/auth/auth.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { convertCurrency } from '../../../shared/utils/utils'
import { ErrorRequestModel } from '../../../core/models/response.model'
import { EditComprasOsLoteModel } from '../../../core/models/reserva-compras.model'

const GESTOR_RESERVA_COMPRAS_PERFIL_ID = 13

@Component({
  selector: 'reserva-compras-edit-lote-modal',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOption,
    MatCheckboxModule,
    CurrencyInputDirective,
  ],
  templateUrl: './reserva-compras-edit-lote-modal.component.html',
  styleUrl: './reserva-compras-edit-lote-modal.component.scss',
  standalone: true,
})
export class ReservaComprasEditLoteModalComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private comprasOrdemServicoService: ComprasOrdemServicoService,
    private supplierService: SupplierService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ReservaComprasEditLoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comprasOsIds: string[] },
  ) {
    this.comprasOsIds = data.comprasOsIds
  }

  @Output() response = new EventEmitter()

  comprasOsIds: string[] = []
  saving = false
  suppliers: any[] = []
  form: FormGroup = new FormGroup({})

  get isGestor(): boolean {
    return (
      this.authService.getInfosObject()?.idPerfil ==
      GESTOR_RESERVA_COMPRAS_PERFIL_ID
    )
  }

  ngOnInit(): void {
    this.createForm()
    this.listSuppliers()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      fornecedorId: ['', Validators.required],
      valorUnitarioMotorista: ['', Validators.required],
      valorUnitarioVeiculo: ['', Validators.required],
      enviarEmail: [true],
      multiplicadorMargem: [0.55],
      valorCusto: [''],
      obsCliente: ['', Validators.maxLength(500)],
      obsFornecedorOperador: ['', Validators.maxLength(500)],
    })
  }

  listSuppliers() {
    this.supplierService.listSupplier('S').subscribe({
      next: (response: any) => {
        this.suppliers = response.data ?? []
      },
      error: () => {
        this.suppliers = []
      },
    })
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    this.saving = true
    const model: EditComprasOsLoteModel = {
      comprasOsIds: this.comprasOsIds,
      fornecedorId: this.form.get('fornecedorId')!.value,
      valorUnitarioMotorista: convertCurrency(
        this.form.get('valorUnitarioMotorista')!.value,
      ) as number,
      valorUnitarioVeiculo: convertCurrency(
        this.form.get('valorUnitarioVeiculo')!.value,
      ) as number,
      enviarEmail: this.form.get('enviarEmail')!.value,
      obsCliente: this.form.get('obsCliente')!.value || null,
      obsFornecedorOperador:
        this.form.get('obsFornecedorOperador')!.value || null,
    }
    const valorCusto = this.form.get('valorCusto')!.value
    if (valorCusto) {
      model.valorCusto = convertCurrency(valorCusto) as number
    }
    if (this.isGestor) {
      model.multiplicadorMargem = this.form.get('multiplicadorMargem')!.value
    }

    this.comprasOrdemServicoService.editComprasOsLote(model).subscribe({
      next: (response: any) => {
        this.saving = false
        const sucesso = response.data?.sucesso ?? []
        const erros = response.data?.erros ?? []
        if (erros.length === 0) {
          this.snackbar.success(
            `${sucesso.length} OS atualizada(s) com sucesso.`,
          )
        } else {
          this.snackbar.warning(
            `${sucesso.length} OS atualizada(s), ${erros.length} falharam: ${erros
              .map((e: any) => e.mensagem)
              .join('; ')}`,
          )
        }
        this.response.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.saving = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  close() {
    this.dialogRef.close()
  }
}
